import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ClausuladoService {
  private rutServicio = AppSettings.rutServiciosINTE + '/api/clausulado/';

  constructor( private httpClient: HttpClient ) {
  }

  obtenerIdentificadorAlfresco( codigoSeguro: string ) {
    return this.httpClient.get( `${this.rutServicio}adjuntoClausulado/codigoSeguro/${codigoSeguro}` ).pipe( map( res => res as any ) );
  }

}
